var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('heading1',[_vm._t("title")],2),_c('div',{staticClass:"lead"},[_vm._t("sentence")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }